var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"layout-background"},[_c('s-side-left'),_c('div',{staticClass:"layout-center"}),_c('s-side-right')],1),_c('div',{attrs:{"id":"main"}},[_c('s-modal-portrait-mode',{attrs:{"visible":_vm.isLandscape}}),_c('router-view')],1),_c('s-footer'),_c('div',{staticClass:"main-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }